import {styled} from '@mui/material/styles';

interface IFrameProps {
  styles?: React.CSSProperties;
  isApp?: boolean;
}

export const StyledIFrame = styled('iframe')(({styles, isApp}: IFrameProps) => ({
  '&.iframeCarousel': {
    width: '100%',
    backgroundColor: 'transparent',
    border: 'none',
    overflowY: 'auto',
    overflowX: 'hidden',
    ...styles
  },

  '&.iframeCarousel.not-loaded': {
    height: 0,
    opacity: 0,
    pointerEvents: 'none'
  },

  '&.iframeCarousel.loaded': {
    minHeight: isApp ? '420px' : '500px',
    opacity: 1,
    transition: 'opacity 0.2s ease-in'
  }
}));
